module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/07introduction#int"
    }
  }, [_c('em', [_vm._v("Introduction")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/07introduction#int"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07introduction#pg9lev1"
    }
  }, [_vm._v("THE LIFE AND TIMES OF GABINA CERVANTES MARTINEZ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/07introduction#pg9lev1"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07introduction#pg10lev1"
    }
  }, [_vm._v("AMÁ’S WEST SIDE KITCHEN")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/07introduction#pg10lev1"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07introduction#pg11lev1"
    }
  }, [_vm._v("TEX-MEX IN LOS ANGELES")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/07introduction#pg11lev1"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08chapter01#ch1"
    }
  }, [_vm._v("CHAPTER 1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08chapter01#ch1"
    }
  }, [_vm._v("LARDER")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/08chapter01#ch1"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09chapter02#pg17lev1"
    }
  }, [_vm._v("Preserved kumquats with lime and chile")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/09chapter02#pg17lev1"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#pg18lev1"
    }
  }, [_vm._v("Preserved kumquat vinaigrette")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#pg18lev1"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#pg21lev1"
    }
  }, [_vm._v("Hoja santa vinaigrette")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#pg21lev1"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter05#pg22lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cascabel-thyme vinaigrette")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/12chapter05#pg22lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter06#pg23lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carrot escabeche")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/13chapter06#pg23lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter07#pg24lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Habanero pickle")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/14chapter07#pg24lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter08#pg25lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pickled oregano onions")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/15chapter08#pg25lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter09#pg27lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pickled gooseberries")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter09#pg27lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17chapter10#pg28lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mexican salmorejo")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/17chapter10#pg28lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18chapter11#pg29lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mexican sriracha")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/18chapter11#pg29lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19chapter12#pg31lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Morita-guajillo salsa")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/19chapter12#pg31lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20chapter13#pg32lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amá spice mix")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/20chapter13#pg32lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21chapter14#pg34lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soldadera’s hot sauce")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/21chapter14#pg34lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("34")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22chapter15#pg35lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesusita’s pequín salsa")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/22chapter15#pg35lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("35")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23chapter16#pg36lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Red-eye spice")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/23chapter16#pg36lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24chapter17#pg37lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salsa de aguacate")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/24chapter17#pg37lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25chapter18#pg38lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pine nut and tepin salsa")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/25chapter18#pg38lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26chapter19#pg41lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cobjini")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/26chapter19#pg41lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("41")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27chapter20#pg43lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tomatillo salsa")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/27chapter20#pg43lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("43")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28chapter21#pg44lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charred green-onion crema")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/28chapter21#pg44lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("44")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29chapter22#pg47lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cascabel pimento cheese")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/29chapter22#pg47lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("47")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30chapter23#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30chapter23#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TEX-MEX BREAKFAST")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/30chapter23#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31chapter24#pg51lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Migas")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/31chapter24#pg51lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("51")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32chapter25#pg52lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Huevos rancheros")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/32chapter25#pg52lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("52")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33chapter26#pg55lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kielbasa and potato scramble")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/33chapter26#pg55lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("55")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34chapter27#pg58lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Broiled piloncillo Texas grapefruit")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/34chapter27#pg58lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("58")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35chapter28#pg59lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tía Carmen’s flour tortillas")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/35chapter28#pg59lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("59")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36chapter29#pg61lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE FIRST TACO OF THE DAY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/36chapter29#pg61lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37chapter30#pg63lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carne guisada")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/37chapter30#pg63lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("63")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38chapter31#pg65lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grandma Alice’s chipotle chorizo")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/38chapter31#pg65lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("65")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39chapter32#pg66lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tía Mona’s picadillo")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/39chapter32#pg66lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("66")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40chapter33#pg67lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Potato and egg breakfast tacos")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/40chapter33#pg67lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("67")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41chapter34#pg69lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Picadillo or chorizo breakfast tacos")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/41chapter34#pg69lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("69")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42chapter35#pg70lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bean, cheese, and bacon breakfast tacos")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/42chapter35#pg70lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("70")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43chapter36#pg73lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Biscuits with bacon gravy")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/43chapter36#pg73lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("73")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/44chapter37#pg75lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cornmeal pancakes with maple-molasses syrup")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/44chapter37#pg75lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("75")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/45chapter38#pg77lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("French Texas toast")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/45chapter38#pg77lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("77")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/46chapter39#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/46chapter39#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AMÁ’S TABLE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/46chapter39#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/47chapter40#pg81lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mama Grande’s chicken soup")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/47chapter40#pg81lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("81")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/48chapter41#pg83lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken and chile tortilla soup")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/48chapter41#pg83lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("83")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/49chapter42#pg85lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grandma Alice’s chorizo and queso asadero")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/49chapter42#pg85lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("85")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/50chapter43#pg86lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Albondigas with tomatillo salsa")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/50chapter43#pg86lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("86")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/51chapter44#pg89lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Slow-roasted beef belly with pomegranate and cotija")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/51chapter44#pg89lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("89")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/52chapter45#pg90lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amá’s carrot and potato sofrito enchiladas")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/52chapter45#pg90lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("90")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/53chapter46#pg93lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mom’s green enchiladas")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/53chapter46#pg93lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("93")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/54chapter47#pg94lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beef cheek barbacoa")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/54chapter47#pg94lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("94")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/55chapter48#pg97lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beef cheek barbacoa enchiladas")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/55chapter48#pg97lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("97")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/56chapter49#pg98lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fideo")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/56chapter49#pg98lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("98")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/57chapter50#pg99lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fideo with octopus")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/57chapter50#pg99lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("99")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/58chapter51#pg103lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chile shrimp ceviche with watercress and avocado")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/58chapter51#pg103lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("103")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/59chapter52#pg104lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scallop aguachile with tomato-habanero water and gooseberries")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/59chapter52#pg104lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("104")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/60chapter53#pg107lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whole roasted sea bream with Tex-Mex chimichurri")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/60chapter53#pg107lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("107")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/61chapter54#pg111lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lobster diablo")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/61chapter54#pg111lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("111")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/62chapter55#pg112lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THEY MET AT OLMOS PHARMACY")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/62chapter55#pg112lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("112")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/63chapter56#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/63chapter56#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VERDURAS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/63chapter56#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114")])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/64chapter57#pg117lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Escarole salad with cotija croutons and banana vinaigrette")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/64chapter57#pg117lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("117")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/65chapter58#pg119lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tex-Mex Caesar salad")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/65chapter58#pg119lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("119")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/66chapter59#pg122lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Watercress, Mahón cheese, nectarines, and creamy lime dressing")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/66chapter59#pg122lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("122")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/67chapter60#pg125lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Broccolini torrada with aged cheddar and lime")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/67chapter60#pg125lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("125")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/68chapter61#pg126lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted cauliflower with cilantro-pecan pesto")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/68chapter61#pg126lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("126")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/69chapter62#pg129lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brussels sprouts with salmorejo and pickled onions")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/69chapter62#pg129lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("129")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/70chapter63#pg130lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sautéed corn with cotija, mushrooms, and bacon")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/70chapter63#pg130lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("130")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/71chapter64#pg133lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Asian squash with piloncillo and butter")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/71chapter64#pg133lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("133")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/72chapter65#pg135lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fried squash blossoms with cascabel pimento cheese")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/72chapter65#pg135lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("135")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/73chapter66#pg136lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sautéed persimmons with crema")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/73chapter66#pg136lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("136")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/74chapter67#pg139lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anchovy butter–roasted red onions")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/74chapter67#pg139lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("139")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/75chapter68#pg140lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CENTENO SUPER MARKETS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/75chapter68#pg140lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("140")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/76chapter69#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/76chapter69#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LA REUNIÓN")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/76chapter69#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("142")])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/77chapter70#pg145lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Borracho beans")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/77chapter70#pg145lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("145")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/78chapter71#pg147lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Refried borracho beans")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/78chapter71#pg147lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("147")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/79chapter72#pg148lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mom’s rice")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/79chapter72#pg148lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("148")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/80chapter73#pg151lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hot sauce chicken with cabbage and kale slaw")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/80chapter73#pg151lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("151")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/81chapter74#pg153lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fried chicken with honey and mint")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/81chapter74#pg153lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("153")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/82chapter75#pg155lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken-fried steak with bacon gravy")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/82chapter75#pg155lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("155")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/83chapter76#pg158lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Black and blue cowboy steak with onion rings")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/83chapter76#pg158lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("158")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/84chapter77#pg160lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dad’s steak fajitas")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/84chapter77#pg160lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("160")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/85chapter78#pg161lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turmeric-ginger chicken fajitas")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/85chapter78#pg161lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("161")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/86chapter79#pg165lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chile shrimp fajitas")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/86chapter79#pg165lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("165")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/87chapter80#pg166lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anchovy pork asada")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/87chapter80#pg166lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("166")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/88chapter81#pg167lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE RANCH")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/88chapter81#pg167lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("167")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/89chapter82#pg169lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tía Alice Jo’s curry-chile pork roast")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/89chapter82#pg169lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("169")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/90chapter83#pg171lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oven-roasted baby back ribs")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/90chapter83#pg171lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("171")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/91chapter84#pg173lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tex-Mex roast turkey")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/91chapter84#pg173lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("173")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/92chapter85#pg176lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turkey chili")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/92chapter85#pg176lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("176")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/93chapter86#pg178lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turkey stock")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/93chapter86#pg178lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("178")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/94chapter87#pg179lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lamb birria")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/94chapter87#pg179lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("179")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/95chapter88#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/95chapter88#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SUPER NACHO HOUR")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/95chapter88#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("182")])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/96chapter89#pg185lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Queso")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/96chapter89#pg185lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("185")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/97chapter90#pg186lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vegan cashew queso")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/97chapter90#pg186lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("186")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/98chapter91#pg187lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tortilla chips")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/98chapter91#pg187lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("187")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/99chapter92#pg189lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amá’s guacamole")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/99chapter92#pg189lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("189")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/100chapter93#pg190lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Super nachos")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/100chapter93#pg190lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("190")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/101chapter94#pg193lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nachos compuestas")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/101chapter94#pg193lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("193")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/102chapter95#pg195lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nana’s deviled eggs with bacon")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/102chapter95#pg195lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("195")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/103chapter96#pg197lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bar Amá chicken wings with hot sauce glaze")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/103chapter96#pg197lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("197")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/104chapter97#pg201lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peel-n-eat shrimp with chile and peanuts")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/104chapter97#pg201lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("201")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/105chapter98#pg202lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cascabel pimento cheese chiles rellenos")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/105chapter98#pg202lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("202")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/106chapter99#pg205lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Corn and cheese taquitos")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/106chapter99#pg205lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("205")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/107chapter100#pg206lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lobster taquitos")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/107chapter100#pg206lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("206")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/108chapter101#pg208lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Borracho bean dip")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/108chapter101#pg208lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("208")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/109chapter102#pg209lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Short rib chalupas")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/109chapter102#pg209lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("209")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/110chapter103#pg210lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My favorite chalupas")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/110chapter103#pg210lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("210")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/111chapter104#pg213lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Corn quesadillas with poblano, cilantro, and green onions")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/111chapter104#pg213lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("213")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/112chapter105#pg214lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carne guisada Frito pie")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/112chapter105#pg214lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("214")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/113chapter106#pg217lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Puffed tacos")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/113chapter106#pg217lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("217")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/114chapter107#pg219lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amá’s margarita")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/114chapter107#pg219lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("219")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/115chapter108#pg220lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Nacho")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/115chapter108#pg220lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("220")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/115chapter108#pg220lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHILE LIME SHRUB")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/115chapter108#pg220lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("220")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/116chapter109#pg223lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("La pina")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/116chapter109#pg223lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("223")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/117chapter110#pg224lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jengibre Baja")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/117chapter110#pg224lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("224")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/117chapter110#pg224lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GINGER SYRUP")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/117chapter110#pg224lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("224")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/118chapter111#pg225lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Juan Collins")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/118chapter111#pg225lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("225")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/119chapter112#pg227lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mezcal negroni")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/119chapter112#pg227lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("227")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/120chapter113#pg228lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("El más chingon")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/120chapter113#pg228lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("228")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/121chapter114#pg231lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Snake’s blood")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/121chapter114#pg231lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("231")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/121chapter114#pg231lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HIBISCUS SYRUP")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/121chapter114#pg231lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("231")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/122chapter115#pg233lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Michelada")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/122chapter115#pg233lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("233")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/122chapter115#pg233lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SANGRITA")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/122chapter115#pg233lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("233")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/123chapter116#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/123chapter116#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DULCES & DESSERTS")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/123chapter116#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("234")])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/124chapter117#pg237lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Berries with hibiscus-ginger syrup")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/124chapter117#pg237lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("237")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/124chapter117#pg237lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HIBISCUS-GINGER SYRUP")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/124chapter117#pg237lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("237")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/125chapter118#pg239lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blood orange flan de queso")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/125chapter118#pg239lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("239")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/126chapter119#pg240lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BRISKET AND COBBLER")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/126chapter119#pg240lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("240")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/127chapter120#pg241lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Churro funnel cakes")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/127chapter120#pg241lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("241")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/128chapter121#pg245lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blueberry cobbler")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/128chapter121#pg245lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("245")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/129chapter122#pg246lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sopapillas")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/129chapter122#pg246lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("246")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/130chapter123#pg248lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cinnamon-fennel conchas")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/130chapter123#pg248lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("248")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/131chapter124#pg250lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mama Hallock’s Pecan Pie")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/131chapter124#pg250lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("250")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/132chapter125#pg252lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vanilla bean semifreddo with dulce de leche")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/132chapter125#pg252lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("252")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/133chapter126#pg255lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fried vanilla bean semifreddo")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/133chapter126#pg255lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("255")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/134chapter127#pg256lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pecan-cacao-coconut sablés")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/134chapter127#pg256lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("256")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/135chapter128#pg259lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tex-leches chocolate-coconut cake")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/135chapter128#pg259lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("259")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/136chapter129#pg261lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capirotada")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/136chapter129#pg261lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("261")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/03dedication#ded"
    }
  }, [_c('em', [_vm._v("Dedication")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/03dedication#ded"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("264")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/138acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/138acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("265")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/139index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/139index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("266")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/140author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/140author",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("273")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29094afd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05contents.vue
// module id = 72
// module chunks = 0